(function() {
	'use strict';
	angular
	.module('app')
	.constant('config', {
		url: 'api/',
		baseUrl: base_url,
		urlUpload: url_upload,
		hashUpload: hash_upload
	});
})(); 